export enum SoundSliceVideoPositionEnum {
  PositionAutomatically = 1,
  VideoLeftOfNotation = 2,
  VideoAboveNotation = 3
}